import ReviewsQueryBase from "@apps/reviews/queries/ReviewsQueryBase";
import { injectable } from "tsyringe";

@injectable()
class ReviewsQuery extends ReviewsQueryBase {}

export default ReviewsQuery;
